import React, { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { getItemDefaultRolesSettings } from '../../../../services/pcwService';
import { RoleSettingSelect } from './RoleSettingSelect';
import _ from 'lodash';

export function RolesSetting({ settings, itemConfiguration, setItemConfiguration, itemType }: any) {
  const defaultRolesSettings = getItemDefaultRolesSettings(itemType);
  const [rolesSettingsValue, setRolesSettingsValue] = useState(
    _.get(itemConfiguration, settings.configurationKey, defaultRolesSettings)
  );

  const updateRolesSettingsValue = (value: any, key: any) => {
    setRolesSettingsValue((prevSettings: any) => ({ ...prevSettings, [key]: value }));
    setItemConfiguration((prevItemConfiguration: any) => {
      return {
        ...prevItemConfiguration,
        [settings.configurationKey]: {
          ...defaultRolesSettings,
          ...prevItemConfiguration[settings.configurationKey],
          [key]: value,
        },
      };
    });
  };

  // DR-9923: suppresses keys that exist in DB records but are managed elsewhere; revert to pcwService default removal after running scripts/migrations/20260817-cleanup-routing-access-superseded-pcw-configs.js
  const excludeKeys: string[] = settings.excludeKeys ?? [];

  return (
    <Box>
      <Grid container spacing={3}>
        {_.map(rolesSettingsValue, (rolesSettingsSelected, key) =>
          excludeKeys.includes(key) ? null : (
            <RoleSettingSelect
              key={key}
              rolesSettingsSelected={rolesSettingsSelected}
              rolesSettingsSelectedKey={key}
              updateRolesSettingsValue={updateRolesSettingsValue}
              itemType={itemType}
              optionsByRoleSettingKey={settings.optionsByRoleSettingKey}
              helperText={settings?.customHelperText?.[key]}
            />
          )
        )}
      </Grid>
    </Box>
  );
}
